function staticTargetKeys() {
  //lif key - default case value
  webmd.ads2.setPageTarget('lif', 0);
  //al key - default case
  webmd.ads2.setPageTarget("al", "0");
  //tug key default case
  webmd.ads2.setPageTarget("tug", "0");
  //rd key
  var rd = window.s_responsive_design ? 1 : 0;
  webmd.ads2.setPageTarget("rd", rd);
  //geoc key
  let geoc =
    PageMetadata.reqHeaders.geoc === null ||
      PageMetadata.reqHeaders.geoc === undefined
      ? "0"
      : PageMetadata.reqHeaders.geoc;
  webmd.ads2.setPageTarget("geoc", geoc);
  //pvb key
  let pvbVal = typeof isMscpApp !== "undefined" && isMscpApp ? "app" : "web";
  webmd.ads2.setPageTarget("pvb", pvbVal);
  //acs key
  if (typeof PageMetadata === 'object' && typeof PageMetadata.authVar === 'object') {
    webmd.ads2.setPageTarget("acs", `${PageMetadata.authVar.authenticationChannel}-${PageMetadata.authVar.authLevel}`);
  }
  else {
    webmd.ads2.setPageTarget("acs", 0);
  }

  //cn key
  webmd.ads2.setPageTarget("cn", "1");

  //sname key
  if (typeof s_md !== "undefined" && s_md != null && s_md.prop3) {
    webmd.ads2.setPageTarget("sname", s_md.prop3);
  }

  // Checking Auth level values and assign Auth key value.
  const authLevel = window.PageMetadata && window.PageMetadata.authVar && window.PageMetadata.authVar.authLevel;
  if (authLevel === "0" || authLevel === "1" || authLevel === "2") {
    webmd.ads2.setPageTarget("auth", authLevel);
  }
}

export { staticTargetKeys as default };

